module.exports = __webpack_public_path__ + "static/media/small-x.b6df441f.svg";